export enum InitializeEditModePolicy {
    CLOSE_ALL = 'CLOSE_ALL',
    OPEN_NEW_COMMENT_IF_NO_COMMENTS = 'OPEN_NEW_COMMENT_IF_NO_COMMENTS',
    OPEN_ALL = 'OPEN_ALL'
}